/* Reuse Proviews' initialized original form; Proviews owns all submissions. */
(function (root) {
  'use strict';
  if (!root || !root.document) return;

  function initialize() {
    var document = root.document;
    var container = document.getElementById('simpAskQuestion');
    if (!container || container.getAttribute('data-ttt-native-form-ready') === 'true') return;
    var host = document.getElementById('tankthetank-qa-native-host');
    var bootstrap = container.querySelector('.ttt-qa-native-bootstrap');
    var controls = container.querySelectorAll('.ttt-qa-native-open');
    if (!host || !bootstrap || !controls.length) return;
    var observer;
    var expiry;
    var nativeInitializationRetried = false;

    function connect() {
      // The final hidden marker is appended after native validation and handlers.
      var forms = document.querySelectorAll('#prorw_question_form');
      var nativeOpen = document.getElementById('prorw_review_summary_action_write_question');
      var marker = document.getElementById('prorw_question_form_call');
      var metadata = document.getElementById('prorw_current_product_info_question');
      var nativeCancel = document.getElementById('prorw_question_cancel_btn');
      var messages = bootstrap.querySelector('.prorw-messages');
      // The app's async script can run before its own widget HTML exists.
      // Retry its original initializer once, never build a replacement form.
      if (!marker && forms.length === 1 && nativeOpen && metadata && nativeCancel && messages
          && !nativeInitializationRetried && typeof root.prorwLoadjQuery === 'function') {
        nativeInitializationRetried = true;
        try { root.prorwLoadjQuery(1); } catch (error) { return false; }
        marker = document.getElementById('prorw_question_form_call');
      }
      if (forms.length !== 1 || !nativeOpen || !marker || !metadata || !nativeCancel || !messages) return false;
      var form = forms[0];
      var wrapper = form.closest('.prorw-question-form-tab');
      if (!wrapper || !bootstrap.contains(wrapper) || !form.contains(marker) || !form.contains(metadata) || !wrapper.contains(nativeCancel)) return false;

      // Move, never clone: preserve native closures, validation and response nodes.
      host.classList.add('prorw-container');
      host.appendChild(messages);
      host.appendChild(wrapper);
      var lastControl = controls[0];
      Array.prototype.forEach.call(controls, function (control) {
        control.addEventListener('click', function () {
          lastControl = control;
          host.hidden = false;
          nativeOpen.click();
        });
        control.disabled = false;
        control.hidden = false;
      });
      // Native Cancel hides the wrapper but leaves its open-toggle closure true.
      // Close through the initialized native toggle instead, before that handler.
      nativeCancel.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (nativeOpen.getAttribute('aria-expanded') === 'true') {
          nativeOpen.click();
          // Proviews finishes slideUp after 300ms. Do not let an immediate
          // reopen race that delayed hide and leave an open-but-invisible form.
          Array.prototype.forEach.call(controls, function (control) { control.disabled = true; });
          root.setTimeout(function () {
            Array.prototype.forEach.call(controls, function (control) { control.disabled = false; });
          }, 350);
        }
        host.hidden = true;
        if (lastControl && typeof lastControl.focus === 'function') lastControl.focus();
      }, true);
      container.setAttribute('data-ttt-native-form-ready', 'true');
      if (observer) observer.disconnect();
      if (expiry) root.clearTimeout(expiry);
      return true;
    }

    if (connect() || !root.MutationObserver) return;
    observer = new root.MutationObserver(connect);
    observer.observe(bootstrap, { childList: true, subtree: true });
    expiry = root.setTimeout(function () {
      observer.disconnect();
      // Leave submission disabled if the official embed never initializes.
      if (container.getAttribute('data-ttt-native-form-ready') !== 'true') {
        container.setAttribute('data-ttt-native-form-ready', 'unavailable');
      }
    }, 30000);
  }

  if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})(typeof window !== 'undefined' ? window : null);
